import SupportPage from '@/models/SupportPage'
import Api from '@/services/api'

export default {
  namespaced: true,
  state: {
    supportPageDetails: null
  },

  mutations: {
    setSupportPageDetails(state, page) {
      if (page instanceof SupportPage) {
        state.supportPageDetails = page
      } else {
        state.supportPageDetails = new SupportPage(page)
      }
    },

    clearSupportPageDetails(state) {
      state.supportPageDetails = null
    }
  },

  actions: {
    async getSupportPageDetails({ commit }, id) {
      const { data } = await Api.get(`support-pages/${id}`)
      commit('setSupportPageDetails', data.data)
    },

    async updateSupportPage({ commit }, formData) {
      const { data } = await Api.put(`support-pages/${formData.id}`, formData)
      commit('setSupportPageDetails', data.data)
    }
  }
}
